// Generated by Avo VERSION 235.16.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Staging = "staging",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "fIj4H3QmGZutJmToGNkg";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "NrliJGrxNjiWh800Xtjy",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "64J0Mrx44bp9vyfV_Na2P",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "NrliJGrxNjiWh800Xtjy",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "64J0Mrx44bp9vyfV_Na2P",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "JmwsgKTQe50MTmUE9FVs",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface CommunicationPreferences {
  newsletterStatus: boolean | null | undefined
}

export const Tab = {
  'ORDERS': 'Orders',
  'OVERVIEW': 'Overview',
  'SETTINGS': 'Settings',
  'SIZE_PASSPORT': 'Size Passport',
} as const;
export type TabType = typeof Tab;
export type TabValueType = TabType[keyof TabType];

export const AddressFields = {
  'ADDRESS_LINE_1': 'Address line 1',
  'CITY': 'City',
  'COUNTRY': 'Country',
  'ZIP_CODE': 'Zip code',
} as const;
export type AddressFieldsType = typeof AddressFields;
export type AddressFieldsValueType = AddressFieldsType[keyof AddressFieldsType];

export const LoggedIn = {
  'FALSE': 'false',
  'TRUE': 'true',
} as const;
export type LoggedInType = typeof LoggedIn;
export type LoggedInValueType = LoggedInType[keyof LoggedInType];

export const AddressType = {
  'BILLING': 'Billing',
  'SHIPPING': 'Shipping',
} as const;
export type AddressTypeType = typeof AddressType;
export type AddressTypeValueType = AddressTypeType[keyof AddressTypeType];

export const EventCategory = {
  'CHECKOUT_INTERACTIONS': 'checkout_interactions',
  'PLP_INTERACTIONS': 'plp_interactions',
  'PDP_INTERACTIONS': 'pdp_interactions',
  'GLOBAL_INTERACTIONS': 'global_interactions',
  'FOOTER_INTERACTIONS': 'footer_interactions',
  'JOURNAL_INTERACTIONS': 'journal_interactions',
  'CM_INTERACTIONS': 'cm_interactions',
  'LOOKBUILDER_INTERACTIONS': 'lookbuilder_interactions',
  'INSTORE_INTERACTIONS': 'instore_interactions',
  'ECOMMERCE_INTERACTIONS': 'ecommerce_interactions',
  'BTC_INTERACTIONS': 'btc_interactions',
  'BOOKING_INTERACTIONS': 'booking_interactions',
  'LOGIN_INTERACTIONS': 'login_interactions',
  'SP_INTERACTIONS': 'sp_interactions',
  'CONFIGURATOR_INTERACTIONS': 'configurator_interactions',
  'RETURNING_ITEM_INTERACTIONS': 'returning_item_interactions',
} as const;
export type EventCategoryType = typeof EventCategory;
export type EventCategoryValueType = EventCategoryType[keyof EventCategoryType];

export const Language = {
  'DE': 'de',
  'EN': 'en',
  'ES': 'es',
  'FR': 'fr',
  'IT': 'it',
  'KO': 'ko',
  'NL': 'nl',
  'PL': 'pl',
  'SV': 'sv',
  'ZH': 'zh',
} as const;
export type LanguageType = typeof Language;
export type LanguageValueType = LanguageType[keyof LanguageType];

export const PageType = {
  'ACCOUNT': 'account',
  'BLACK_TIE_CONFIGURATOR': 'black-tie-configurator',
  'BLACK_TIE_CONFIGURATOR': 'black_tie_configurator',
  'BOOKING_TOOL': 'booking_tool',
  'CART': 'cart',
  'CATEGORY': 'category',
  'CATEGORY_LANDING': 'category_landing',
  'CHECKOUT': 'checkout',
  'CUSTOMMADE': 'custommade',
  'EMPLOYEE_PROFILE': 'employee_profile',
  'ERROR': 'error',
  'GIFTCARD': 'giftcard',
  'HOME': 'home',
  'INSTORE': 'instore',
  'JOURNAL': 'journal',
  'LOGIN': 'login',
  'LOOKBUILDER': 'lookbuilder',
  'MINI_CART': 'mini-cart',
  'ORDER_CONFIRMATION': 'order_confirmation',
  'PRODUCT': 'product',
  'PRODUCT_DETAIL_PAGE': 'product_detail_page',
  'PRODUCT_LIST_PAGE': 'product_list_page',
  'RETURN': 'return',
  'RETURN_CONFIRMATION': 'return_confirmation',
  'STORE': 'store',
  'STORE_DETAILS': 'store_details',
  'STORE_LOCATOR': 'store_locator',
  'STORE_OVERVIEW': 'store_overview',
  'SUPPORT': 'support',
  'WISHLIST': 'wishlist',
} as const;
export type PageTypeType = typeof PageType;
export type PageTypeValueType = PageTypeType[keyof PageTypeType];

export const UserType = {
  'CUSTOMER': 'Customer',
  'STYLE_ADVISOR': 'Style Advisor',
} as const;
export type UserTypeType = typeof UserType;
export type UserTypeValueType = UserTypeType[keyof UserTypeType];

export const Rating = {
  'BAD': 'bad',
  'GOOD': 'good',
} as const;
export type RatingType = typeof Rating;
export type RatingValueType = RatingType[keyof RatingType];

export const Country = {
  'AE': 'ae',
  'AT': 'at',
  'AU': 'au',
  'BE': 'be',
  'BG': 'bg',
  'BN': 'bn',
  'CA': 'ca',
  'CH': 'ch',
  'CN': 'cn',
  'CY': 'cy',
  'CZ': 'cz',
  'DE': 'de',
  'DK': 'dk',
  'DO': 'do',
  'EE': 'ee',
  'ES': 'es',
  'FI': 'fi',
  'FR': 'fr',
  'GB': 'gb',
  'GH': 'gh',
  'GI': 'gi',
  'GP': 'gp',
  'GR': 'gr',
  'GW': 'gw',
  'HK': 'hk',
  'HR': 'hr',
  'HU': 'hu',
  'IE': 'ie',
  'IN': 'in',
  'IR': 'ir',
  'IS': 'is',
  'IT': 'it',
  'JE': 'je',
  'JP': 'jp',
  'KR': 'kr',
  'LI': 'li',
  'LT': 'lt',
  'LU': 'lu',
  'LV': 'lv',
  'LY': 'ly',
  'MC': 'mc',
  'MO': 'mo',
  'MQ': 'mq',
  'MT': 'mt',
  'MV': 'mv',
  'MY': 'my',
  'NL': 'nl',
  'NO': 'no',
  'PL': 'pl',
  'PR': 'pr',
  'PT': 'pt',
  'QA': 'qa',
  'RO': 'ro',
  'SE': 'se',
  'SG': 'sg',
  'SI': 'si',
  'SK': 'sk',
  'TT': 'tt',
  'US': 'us',
} as const;
export type CountryType = typeof Country;
export type CountryValueType = CountryType[keyof CountryType];

export const Currency = {
  'EUR': 'eur',
  'USD': 'usd',
  'CNY': 'cny',
  'AUD': 'aud',
  'BGN': 'bgn',
  'CAD': 'cad',
  'CZK': 'czk',
  'DKK': 'dkk',
  'HKD': 'hkd',
  'HUF': 'huf',
  'ISK': 'isk',
  'INR': 'inr',
  'JPY': 'jpy',
  'CHF': 'chf',
  'MOP': 'mop',
  'MYR': 'myr',
  'NOK': 'nok',
  'QAR': 'qar',
  'RON': 'ron',
  'SGD': 'sgd',
  'SEK': 'sek',
  'AED': 'aed',
  'GBP': 'gbp',
  'PLN': 'pln',
  'KRW': 'krw',
} as const;
export type CurrencyType = typeof Currency;
export type CurrencyValueType = CurrencyType[keyof CurrencyType];

export const CardType = {
  'ALTERATION': 'Alteration',
  'ORDER': 'Order',
} as const;
export type CardTypeType = typeof CardType;
export type CardTypeValueType = CardTypeType[keyof CardTypeType];

export const ApplicationId = {
  'CUSTOMER_HUB': 'customer_hub',
} as const;
export type ApplicationIdType = typeof ApplicationId;
export type ApplicationIdValueType = ApplicationIdType[keyof ApplicationIdType];

let sysApplicationId: any;
let sysVersion: any;
let sysAffiliateMarker: any;
let sysAwc: any;
let sysCountry: any;
let sysLanguage: any;
let sysLocationId: any;
let sysUserId: any;
let sysLoggedIn: any;
let sysPageType: any;
let sysGaClientId: any;
let sysGaSessionId: any;
let sysGaSessionNumber: any;
let sysFbFbp: any;
let sysFbFbc: any;
let sysGaAwClid: any;
let sysTtclid: any;
let sysMsclkid: any;
let sysTwclid: any;
let sysRdtCid: any;
let sysEpik: any;

export function setSystemProperties(properties: {applicationId: ApplicationIdValueType;
    version: string;
    affiliateMarker: string;
    awc: string;
    country: CountryValueType;
    language: LanguageValueType;
    locationId: string;
    userId: string;
    loggedIn: LoggedInValueType;
    pageType: PageTypeValueType;
    gaClientId: string;
    gaSessionId: string;
    gaSessionNumber: string;
    fbFbp: string;
    fbFbc: string;
    gaAwClid: string;
    ttclid: string;
    msclkid: string;
    twclid: string;
    rdtCid: string;
    epik: string}) {
  if (properties.applicationId !== null && properties.applicationId !== undefined) {
    sysApplicationId = properties.applicationId;
  }
  if (properties.version !== null && properties.version !== undefined) {
    sysVersion = properties.version;
  }
  if (properties.affiliateMarker !== null && properties.affiliateMarker !== undefined) {
    sysAffiliateMarker = properties.affiliateMarker;
  }
  if (properties.awc !== null && properties.awc !== undefined) {
    sysAwc = properties.awc;
  }
  if (properties.country !== null && properties.country !== undefined) {
    sysCountry = properties.country;
  }
  if (properties.language !== null && properties.language !== undefined) {
    sysLanguage = properties.language;
  }
  if (properties.locationId !== null && properties.locationId !== undefined) {
    sysLocationId = properties.locationId;
  }
  if (properties.userId !== null && properties.userId !== undefined) {
    sysUserId = properties.userId;
  }
  if (properties.loggedIn !== null && properties.loggedIn !== undefined) {
    sysLoggedIn = properties.loggedIn;
  }
  if (properties.pageType !== null && properties.pageType !== undefined) {
    sysPageType = properties.pageType;
  }
  if (properties.gaClientId !== null && properties.gaClientId !== undefined) {
    sysGaClientId = properties.gaClientId;
  }
  if (properties.gaSessionId !== null && properties.gaSessionId !== undefined) {
    sysGaSessionId = properties.gaSessionId;
  }
  if (properties.gaSessionNumber !== null && properties.gaSessionNumber !== undefined) {
    sysGaSessionNumber = properties.gaSessionNumber;
  }
  if (properties.fbFbp !== null && properties.fbFbp !== undefined) {
    sysFbFbp = properties.fbFbp;
  }
  if (properties.fbFbc !== null && properties.fbFbc !== undefined) {
    sysFbFbc = properties.fbFbc;
  }
  if (properties.gaAwClid !== null && properties.gaAwClid !== undefined) {
    sysGaAwClid = properties.gaAwClid;
  }
  if (properties.ttclid !== null && properties.ttclid !== undefined) {
    sysTtclid = properties.ttclid;
  }
  if (properties.msclkid !== null && properties.msclkid !== undefined) {
    sysMsclkid = properties.msclkid;
  }
  if (properties.twclid !== null && properties.twclid !== undefined) {
    sysTwclid = properties.twclid;
  }
  if (properties.rdtCid !== null && properties.rdtCid !== undefined) {
    sysRdtCid = properties.rdtCid;
  }
  if (properties.epik !== null && properties.epik !== undefined) {
    sysEpik = properties.epik;
  }
}

let Segment: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {applicationId: ApplicationIdValueType;
    version: string;
    affiliateMarker: string;
    awc: string;
    country: CountryValueType;
    language: LanguageValueType;
    locationId: string;
    userId: string;
    loggedIn: LoggedInValueType;
    pageType: PageTypeValueType;
    gaClientId: string;
    gaSessionId: string;
    gaSessionNumber: string;
    fbFbp: string;
    fbFbc: string;
    gaAwClid: string;
    ttclid: string;
    msclkid: string;
    twclid: string;
    rdtCid: string;
    epik: string},
    destinationOptions: any,
    SegmentDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  setSystemProperties(systemProperties);
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    if (__AVO_ENV__ === AvoEnv.Staging) {
    }
    
    Segment = SegmentDestination;
    if (__AVO_ENV__ === 'prod') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, "4OhwIsrqFzQ0aeuYev8muGSWiimGtGIG");
    } else if (__AVO_ENV__ === 'dev') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    } else {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertQuantity(quantity: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertInt("fg1kaNXr_", _label ? "quantity" + ': ' + _label : "quantity", quantity));
  messages = messages.concat(AvoAssert.assertMin("fg1kaNXr_", _label ? "quantity" + ": " + _label : "quantity", 1, quantity));
  return messages;
}

function assertCommunicationPreferences(communicationPreferences: CommunicationPreferences,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertObject("sDlh7c0yvS7a0T6AcoGcQ", _label ? "communication_preferences" + ': ' + _label : "communication_preferences", communicationPreferences));
  if (communicationPreferences !== null && communicationPreferences !== undefined) {
  }
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface FaqOpenProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string | null | undefined;
  userType: UserTypeValueType[];
}
/**
 * faq_open: When clicking in the navigation menu of support links
 * event_label: faq question in native language
 * 
 * When to trigger this event:
 * 1. when clicking on the faq dropdown links 

event_location: support-page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/nqxV9XZOW/trigger/VJ9-V4AXb
 * 2. When a user clicks on an faq accordion in the order details in the customer hub
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/nqxV9XZOW/trigger/rsuWW8iDkMChnH3F6kQGq
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/nqxV9XZOW}
 */
export function faqOpen(properties: FaqOpenProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  properties.eventLocation !== undefined && properties.eventLocation !== null ?
    eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation}) :
    eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: null});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "nqxV9XZOW", "6c52e5e90db20dfbca68e7d90d80de9cf814e5077c7826e465e4c3823ff71351", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("faq_open", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("nqxV9XZOW", "faq_open", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("faq_open", eventProperties, "nqxV9XZOW", "6c52e5e90db20dfbca68e7d90d80de9cf814e5077c7826e465e4c3823ff71351");
    }
    // destination Segment
    Segment.logEvent("faq_open", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomerInformationEditedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
}
/**
 * customer_information_edited: This event represents when the customer infromation has been modified from the customer hub by a Style Advisor.
 * 
 * When to trigger this event:
 * 1. the "save" button is clicked on the edit customer information screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/be2cabe1-63d9-47f8-9783-3cc406fb639b/trigger/d89jVIhK51-lSXl3txPTr
 * 2. When a user clicks "save info" and successfully updates the customer information in the new customer hub
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/be2cabe1-63d9-47f8-9783-3cc406fb639b/trigger/NYuh7L1xlJnCEprvwwfiy
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/be2cabe1-63d9-47f8-9783-3cc406fb639b}
 */
export function customerInformationEdited(properties: CustomerInformationEditedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "be2cabe1-63d9-47f8-9783-3cc406fb639b", "87ec8dd04370e62bc72854746d312bea238980c9873d98c040e8fb06faf44d61", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("customer_information_edited", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("be2cabe1-63d9-47f8-9783-3cc406fb639b", "customer_information_edited", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("customer_information_edited", eventProperties, "be2cabe1-63d9-47f8-9783-3cc406fb639b", "87ec8dd04370e62bc72854746d312bea238980c9873d98c040e8fb06faf44d61");
    }
    // destination Segment
    Segment.logEvent("customer_information_edited", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomerHubOpenedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
}
/**
 * customer_hub_opened: This event represents when the customer hub page is opened.
 * 
 * When to trigger this event:
 * 1. the customer tile is clicked with a customer selected on predict spring
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/cc8cee64-999e-4e36-8c3d-3d10ae465998/trigger/uV9LxePJkDMSRGl6FqnBy
 * 2. clicking on the "cutomer" option in the "Cart Options" menu
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/cc8cee64-999e-4e36-8c3d-3d10ae465998/trigger/yxgor0FU2qi4A4kYBuJUR
 * 3. there is no customer selected on predict spring, selecting a customer from the active customer list.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/cc8cee64-999e-4e36-8c3d-3d10ae465998/trigger/y8VGkcAZTb8zsN-ButAe_
 * 4. Clicking on the "account" icon on the channels where customer hub is enabled. (not my account)
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/cc8cee64-999e-4e36-8c3d-3d10ae465998/trigger/NhNX_i_ulDbQhA3QAB_y0
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/cc8cee64-999e-4e36-8c3d-3d10ae465998}
 */
export function customerHubOpened(properties: CustomerHubOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "cc8cee64-999e-4e36-8c3d-3d10ae465998", "4043f60ec295d0ba647a288b49b4b6e8544dd503c9106bceac7b40661b9e54ba", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("customer_hub_opened", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("cc8cee64-999e-4e36-8c3d-3d10ae465998", "customer_hub_opened", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("customer_hub_opened", eventProperties, "cc8cee64-999e-4e36-8c3d-3d10ae465998", "4043f60ec295d0ba647a288b49b4b6e8544dd503c9106bceac7b40661b9e54ba");
    }
    // destination Segment
    Segment.logEvent("customer_hub_opened", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomerSelectedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
}
/**
 * customer_selected: This event represents when the users click on "select user" to select the user on predict spring
 * 
 * When to trigger this event:
 * 1. the user clicks on "select customer"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MmyQXjjKAjQinUfmWeYae/trigger/yxgK3OlTAahnURmXXHMW2
 * 2. When a style advisor clicks on "select customer
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MmyQXjjKAjQinUfmWeYae/trigger/9FXVLKMc5ZYjVz1flM1bW
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MmyQXjjKAjQinUfmWeYae}
 */
export function customerSelected(properties: CustomerSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MmyQXjjKAjQinUfmWeYae", "2e3df0235ba65c7a0d407607927b5bc5f8dbef2092da91e178cc634745e0279b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("customer_selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MmyQXjjKAjQinUfmWeYae", "customer_selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("customer_selected", eventProperties, "MmyQXjjKAjQinUfmWeYae", "2e3df0235ba65c7a0d407607927b5bc5f8dbef2092da91e178cc634745e0279b");
    }
    // destination Segment
    Segment.logEvent("customer_selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ReturnOrderClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  orderId: string;
  userType: UserTypeValueType[];
  currency: CurrencyValueType | null | undefined;
}
/**
 * return_order_clicked: This event represents when the user clicks in the "Return" button in the Orders and Returns section
 * 
 * When to trigger this event:
 * 1. Then the user clicks in the "Return" button in the orders and returns
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Et2HOk3VLBzOtAOPg9Ojz/trigger/ZLnatqtGTTGVuLb1RXO4n
 * 2. When a customer clicks on "return" on the order details in the customer hub
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Et2HOk3VLBzOtAOPg9Ojz/trigger/V3o7UWw37t_PKKDm1u1xJ
 * 3. the user clicks "return or exchange" or "return" on an active card
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Et2HOk3VLBzOtAOPg9Ojz/trigger/mL2DbQaKdD31AClzVfrv-
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.orderId: transaction id (native property of ecommerce object within Segment)
 * @param properties.userType: Describes whee
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Et2HOk3VLBzOtAOPg9Ojz}
 */
export function returnOrderClicked(properties: ReturnOrderClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "9aTQ52H3v", name: "order_id", value: properties.orderId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Et2HOk3VLBzOtAOPg9Ojz", "5589fc5f9b83a7ecc254346352ea3912cc415ed0c67c4c302776bed4753ba7f9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("return_order_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Et2HOk3VLBzOtAOPg9Ojz", "return_order_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("return_order_clicked", eventProperties, "Et2HOk3VLBzOtAOPg9Ojz", "5589fc5f9b83a7ecc254346352ea3912cc415ed0c67c4c302776bed4753ba7f9");
    }
    // destination Segment
    Segment.logEvent("return_order_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomerAddressEditedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  addressType: AddressTypeValueType;
  addressFields: AddressFieldsValueType[];
  userType: UserTypeValueType[];
}
/**
 * customer_address_edited: This event describes when a customer's address has been modified
 * 
 * When to trigger this event:
 * 1. When a user clicks "save customer" and successfully modifies the address details
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/9c21e419-91d6-4e74-a600-5228c0a22d58/trigger/Tdb0FNaUCr975IJO_Reid
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.addressType: Describes whether an address is shipping or biling
 * @param properties.addressFields: Lists the modified address fields
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/9c21e419-91d6-4e74-a600-5228c0a22d58}
 */
export function customerAddressEdited(properties: CustomerAddressEditedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "NTf3wiPrNhZYoGPbu5xg0", name: "address_type", value: properties.addressType});
  eventPropertiesArray.push({id: "Mh0cvTEd1tBnL3b_buJs2", name: "address_fields", value: properties.addressFields});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "9c21e419-91d6-4e74-a600-5228c0a22d58", "398b71bf210749d94a5db949cfa97a8e9fc8f25567101d3b387c01591c79928b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("customer_address_edited", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("9c21e419-91d6-4e74-a600-5228c0a22d58", "customer_address_edited", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("customer_address_edited", eventProperties, "9c21e419-91d6-4e74-a600-5228c0a22d58", "398b71bf210749d94a5db949cfa97a8e9fc8f25567101d3b387c01591c79928b");
    }
    // destination Segment
    Segment.logEvent("customer_address_edited", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TabClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  tab: TabValueType[];
  userType: UserTypeValueType[];
}
/**
 * tab_clicked: This event describes when a tab of the customer hub has been clicked
 * 
 * When to trigger this event:
 * 1. When a user clicks the tab bar on the customer hub
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/bgEzIsGIogX13Uqyvz19l/trigger/TVETQeNgo7ph5LW4rriyW
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.tab: Describes the selected name of the tab in the customer hub
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/bgEzIsGIogX13Uqyvz19l}
 */
export function tabClicked(properties: TabClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "5jZOdXVfj_sphp1VsS1HD", name: "tab", value: properties.tab});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "bgEzIsGIogX13Uqyvz19l", "5cf16838cfae7f1bb810bcca81a9d422ad2d2c33038abc245f1505ee1b02aa3b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("tab_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("bgEzIsGIogX13Uqyvz19l", "tab_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("tab_clicked", eventProperties, "bgEzIsGIogX13Uqyvz19l", "5cf16838cfae7f1bb810bcca81a9d422ad2d2c33038abc245f1505ee1b02aa3b");
    }
    // destination Segment
    Segment.logEvent("tab_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ReturnedToAclProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
}
/**
 * returned_to_acl: This event describes when a style advisor click on "customers in store" to see the ACL
 * 
 * When to trigger this event:
 * 1. When a style advisor clicks on "customers in store" to return to the ACL
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/VTYSeTM1Mj9MZjYMNYAhT/trigger/ajJ55Ib3kSFTHmNEFcm-X
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/VTYSeTM1Mj9MZjYMNYAhT}
 */
export function returnedToAcl(properties: ReturnedToAclProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "VTYSeTM1Mj9MZjYMNYAhT", "c757709349bbd66f87d70427d0c35f31f0e160114d2aa4421ddda0099d72ce1e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("returned_to_acl", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("VTYSeTM1Mj9MZjYMNYAhT", "returned_to_acl", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("returned_to_acl", eventProperties, "VTYSeTM1Mj9MZjYMNYAhT", "c757709349bbd66f87d70427d0c35f31f0e160114d2aa4421ddda0099d72ce1e");
    }
    // destination Segment
    Segment.logEvent("returned_to_acl", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OrderClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
  orderId: string;
}
/**
 * order_clicked: This event describes when customer's order on their order history has been clicked
 * 
 * When to trigger this event:
 * 1. When a user clicks on an order in the order history
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MVSN9ZtFs6RAxra-nQVpa/trigger/P5UOj0rV51xrEZxPk6gO6
 * 2. A user clicks on an order in the active card in the overview
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MVSN9ZtFs6RAxra-nQVpa/trigger/1KpVirg1b87uIqKoUxB_b
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * @param properties.orderId: transaction id (native property of ecommerce object within Segment)
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MVSN9ZtFs6RAxra-nQVpa}
 */
export function orderClicked(properties: OrderClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "9aTQ52H3v", name: "order_id", value: properties.orderId});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MVSN9ZtFs6RAxra-nQVpa", "11d4f7c32f395481356744fc80d9e8fa5f89f7d003b52ea37161a719fdeef786", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("order_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MVSN9ZtFs6RAxra-nQVpa", "order_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("order_clicked", eventProperties, "MVSN9ZtFs6RAxra-nQVpa", "11d4f7c32f395481356744fc80d9e8fa5f89f7d003b52ea37161a719fdeef786");
    }
    // destination Segment
    Segment.logEvent("order_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CommunicationPreferencesSavedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  communicationPreferences: CommunicationPreferences;
  userType: UserTypeValueType[];
}
/**
 * communication_preferences_saved: This event described when the customer has saved communication preferences
 * 
 * When to trigger this event:
 * 1. when the user clicks "save preferences"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/N6CHO6B8mWvD4lvsmcmRb/trigger/jiArMR2idnn0in04cFW1C
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.communicationPreferences: The customer's communication preferences
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/N6CHO6B8mWvD4lvsmcmRb}
 */
export function communicationPreferencesSaved(properties: CommunicationPreferencesSavedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "sDlh7c0yvS7a0T6AcoGcQ", name: "communication_preferences", value: {
    "newsletter_status": properties.communicationPreferences.newsletterStatus,
  }});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertCommunicationPreferences(properties.communicationPreferences));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "N6CHO6B8mWvD4lvsmcmRb", "c53724e3a6d5a36edcd9ebd249e871caf5e103d74659c7f8d4a4170743c7bcf2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("communication_preferences_saved", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("N6CHO6B8mWvD4lvsmcmRb", "communication_preferences_saved", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'communication_preferences_saved': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("communication_preferences_saved", eventProperties, "N6CHO6B8mWvD4lvsmcmRb", "c53724e3a6d5a36edcd9ebd249e871caf5e103d74659c7f8d4a4170743c7bcf2");
    }
    // destination Segment
    Segment.logEvent("communication_preferences_saved", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NewArrivalsButtonClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
}
/**
 * new_arrivals_button_clicked: This event represents when the user clicks in the "Shop new arrivals" button in the customer hub
 * 
 * When to trigger this event:
 * 1. When a customer clicks on "shop new arrivals" from the customer hub. This button is only visible when they have no  updates on their overview
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/2e01307a-ea0d-4c9c-ba09-14ff4c7a888f/trigger/WY9hvzhxf9lLMoVVbc1-Z
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/2e01307a-ea0d-4c9c-ba09-14ff4c7a888f}
 */
export function newArrivalsButtonClicked(properties: NewArrivalsButtonClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2e01307a-ea0d-4c9c-ba09-14ff4c7a888f", "779d770bed305182434b038fe3f67d14c740686668ff81bb144539c2af7afd2c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("new_arrivals_button_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2e01307a-ea0d-4c9c-ba09-14ff4c7a888f", "new_arrivals_button_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("new_arrivals_button_clicked", eventProperties, "2e01307a-ea0d-4c9c-ba09-14ff4c7a888f", "779d770bed305182434b038fe3f67d14c740686668ff81bb144539c2af7afd2c");
    }
    // destination Segment
    Segment.logEvent("new_arrivals_button_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SettingsCustomerInfoClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
}
/**
 * settings_customer_info_clicked: This event represents when a user clicks on the customer info button under settings
 * 
 * When to trigger this event:
 * 1. When a user clicks on "customer info"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/B-nr5FPBPtL-njqNNQ4Lu/trigger/77gsvvpAAj_07cU8MLyTb
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/B-nr5FPBPtL-njqNNQ4Lu}
 */
export function settingsCustomerInfoClicked(properties: SettingsCustomerInfoClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "B-nr5FPBPtL-njqNNQ4Lu", "76c3f95404e0f2ef48134b2840241ff9a869097a9566ac54a3bd3d2e8e99dfa8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("settings_customer_info_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("B-nr5FPBPtL-njqNNQ4Lu", "settings_customer_info_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("settings_customer_info_clicked", eventProperties, "B-nr5FPBPtL-njqNNQ4Lu", "76c3f95404e0f2ef48134b2840241ff9a869097a9566ac54a3bd3d2e8e99dfa8");
    }
    // destination Segment
    Segment.logEvent("settings_customer_info_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SettingsAddressBookClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
}
/**
 * settings_address_book_clicked: This event represents when a user clicks on the address book button under settings
 * 
 * When to trigger this event:
 * 1. When a user clicks on "address book"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/q4Pag3w2ofW-fm1o5B6_J/trigger/AlVnZnB0E9dSqEYdb1C74
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/q4Pag3w2ofW-fm1o5B6_J}
 */
export function settingsAddressBookClicked(properties: SettingsAddressBookClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "q4Pag3w2ofW-fm1o5B6_J", "b4565989156351683e14ff7157e8a4b2a0d89f7cda3ceddeb6cb965a129a7a70", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("settings_address_book_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("q4Pag3w2ofW-fm1o5B6_J", "settings_address_book_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("settings_address_book_clicked", eventProperties, "q4Pag3w2ofW-fm1o5B6_J", "b4565989156351683e14ff7157e8a4b2a0d89f7cda3ceddeb6cb965a129a7a70");
    }
    // destination Segment
    Segment.logEvent("settings_address_book_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SettingsCommunicationClickledProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
}
/**
 * settings_communication_clickled: This event represents when a user clicks on the communication button under settings
 * 
 * When to trigger this event:
 * 1. When a user clicks on "communication"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/2B48i2SVxemc1RBRxObLH/trigger/ptXm6DIe6sqRfbQTwAh8n
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/2B48i2SVxemc1RBRxObLH}
 */
export function settingsCommunicationClickled(properties: SettingsCommunicationClickledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2B48i2SVxemc1RBRxObLH", "bb0bb79617830855a486f7da247757afc3c2428b1ccf0435e1c0d6d8ed95c59b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("settings_communication_clickled", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2B48i2SVxemc1RBRxObLH", "settings_communication_clickled", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("settings_communication_clickled", eventProperties, "2B48i2SVxemc1RBRxObLH", "bb0bb79617830855a486f7da247757afc3c2428b1ccf0435e1c0d6d8ed95c59b");
    }
    // destination Segment
    Segment.logEvent("settings_communication_clickled", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CancellationClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
}
/**
 * cancellation_clicked: This event describes when a user starts the cancellation process
 * 
 * When to trigger this event:
 * 1. When the user clicks on "cancel items" in the order details page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/8db5d22f-851b-4c1f-b3d8-01629eb74ad3/trigger/rNwS0GgdrFw-zm5WiIDS5
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/8db5d22f-851b-4c1f-b3d8-01629eb74ad3}
 */
export function cancellationClicked(properties: CancellationClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8db5d22f-851b-4c1f-b3d8-01629eb74ad3", "8d45d633582134b4616e44c1cb35817895db3fcf6d01c717a37ab43760c89e35", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cancellation_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8db5d22f-851b-4c1f-b3d8-01629eb74ad3", "cancellation_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cancellation_clicked", eventProperties, "8db5d22f-851b-4c1f-b3d8-01629eb74ad3", "8d45d633582134b4616e44c1cb35817895db3fcf6d01c717a37ab43760c89e35");
    }
    // destination Segment
    Segment.logEvent("cancellation_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CancellationApprovedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
}
/**
 * cancellation_approved: This event describes when an authorised user approved the cancellation process
 * 
 * When to trigger this event:
 * 1. When the user clicks "continue" after providing valid credentials
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/P18E3n995E8S67yLS4J6X/trigger/KfS--jyoyrP_iTSlp6_4j
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/P18E3n995E8S67yLS4J6X}
 */
export function cancellationApproved(properties: CancellationApprovedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "P18E3n995E8S67yLS4J6X", "ef62832dadb90faa4d78341eff8dd741d275c991c13a72d2cd3f4f37570ac4e2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cancellation_approved", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("P18E3n995E8S67yLS4J6X", "cancellation_approved", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cancellation_approved", eventProperties, "P18E3n995E8S67yLS4J6X", "ef62832dadb90faa4d78341eff8dd741d275c991c13a72d2cd3f4f37570ac4e2");
    }
    // destination Segment
    Segment.logEvent("cancellation_approved", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CancellationConfirmedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  employeeId: string;
  userType: UserTypeValueType[];
}
/**
 * cancellation_confirmed: This event describes when a user confirms the cancellation process, triggering a cancellation.
 * 
 * When to trigger this event:
 * 1. When the user clicks "Confirm cancellation" con the confirm cancellation screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/WYrk2arXC-2YcHwWk6G64/trigger/gFVzbvNYJ2PWJFLou8J4T
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/WYrk2arXC-2YcHwWk6G64}
 */
export function cancellationConfirmed(properties: CancellationConfirmedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "WYrk2arXC-2YcHwWk6G64", "9eb4f00df2bfad40330840ff74b774cd3cf39d7aa665149f9e684d79d9c8f84d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cancellation_confirmed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("WYrk2arXC-2YcHwWk6G64", "cancellation_confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cancellation_confirmed", eventProperties, "WYrk2arXC-2YcHwWk6G64", "9eb4f00df2bfad40330840ff74b774cd3cf39d7aa665149f9e684d79d9c8f84d");
    }
    // destination Segment
    Segment.logEvent("cancellation_confirmed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TrackYourOrderClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  orderId: string;
  userType: UserTypeValueType[];
}
/**
 * track_your_order_clicked: Fired when a customer or style advisor taps "Track your order" on an Active Card in the Customer Hub.
 * 
 * When to trigger this event:
 * 1. a user clicks "track order" on an active card
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/GCsMdnbYkE0niN5zlEnOM/trigger/hNk65zrKeV38ScjVV0WVe
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.orderId: transaction id (native property of ecommerce object within Segment)
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/GCsMdnbYkE0niN5zlEnOM}
 */
export function trackYourOrderClicked(properties: TrackYourOrderClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "9aTQ52H3v", name: "order_id", value: properties.orderId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: "active_card"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "GCsMdnbYkE0niN5zlEnOM", "31b12a8ec614afa2357846b195a3c0dd17dee44826b7339aeafae519e2e034c7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("track_your_order_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("GCsMdnbYkE0niN5zlEnOM", "track_your_order_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("track_your_order_clicked", eventProperties, "GCsMdnbYkE0niN5zlEnOM", "31b12a8ec614afa2357846b195a3c0dd17dee44826b7339aeafae519e2e034c7");
    }
    // destination Segment
    Segment.logEvent("track_your_order_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookPickupAppointmentClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  orderId: string;
  userType: UserTypeValueType[];
  cardType: CardTypeValueType;
}
/**
 * book_pickup_appointment_clicked: Fired when a customer or style advisor taps "Book appointment" on an Active Card (order or alteration) once it is ready for store pickup.
 * 
 * When to trigger this event:
 * 1. A user clicks on "book a pick-up appointment" in an active card
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/flniyA3CCJh0afQUfsan2/trigger/E2EW1D6pluNVONVgfNVFp
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.orderId: transaction id (native property of ecommerce object within Segment)
 * @param properties.userType: Describes whee
 * @param properties.cardType: Whether this Active Card is an order card or an alteration card.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/flniyA3CCJh0afQUfsan2}
 */
export function bookPickupAppointmentClicked(properties: BookPickupAppointmentClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "9aTQ52H3v", name: "order_id", value: properties.orderId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "jzkiA5tr__EMF5lu6ggsa", name: "card_type", value: properties.cardType});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: "active_card"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "flniyA3CCJh0afQUfsan2", "cfacc42b0e251b48ed585563392ef70400b0757006c1190c6c7cee10f27c1c18", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("book_pickup_appointment_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("flniyA3CCJh0afQUfsan2", "book_pickup_appointment_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("book_pickup_appointment_clicked", eventProperties, "flniyA3CCJh0afQUfsan2", "cfacc42b0e251b48ed585563392ef70400b0757006c1190c6c7cee10f27c1c18");
    }
    // destination Segment
    Segment.logEvent("book_pickup_appointment_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ItemsInCartLoadedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
}
/**
 * items_in_cart_loaded: Describes when the items in cart component is loaded in the customer hub
 * 
 * When to trigger this event:
 * 1. The items in cart component is shown on screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/REgCyhobVD7EYd77kZ6ZA/trigger/RMt1BfBvKAnZD0vCS1L4b
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/REgCyhobVD7EYd77kZ6ZA}
 */
export function itemsInCartLoaded(properties: ItemsInCartLoadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "REgCyhobVD7EYd77kZ6ZA", "59bf8489982cd1720a1aa60aa48bfa32be4b76edb889b889730150d76c7f727c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("items_in_cart_loaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("REgCyhobVD7EYd77kZ6ZA", "items_in_cart_loaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("items_in_cart_loaded", eventProperties, "REgCyhobVD7EYd77kZ6ZA", "59bf8489982cd1720a1aa60aa48bfa32be4b76edb889b889730150d76c7f727c");
    }
    // destination Segment
    Segment.logEvent("items_in_cart_loaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WardrobeItemClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  userType: UserTypeValueType[];
  productId: string;
  category: string;
  quantity: number;
  isCustomMade: boolean;
}
/**
 * wardrobe_item_clicked: Describes when a User taps a product card in the Wardrobe tab, opening the detail panel
 * 
 * When to trigger this event:
 * 1. User taps a product card in the Wardrobe tab, opening the detail panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/1b13f173-a519-455f-b26d-a1685ccda6b5/trigger/_xNQCjypxO4F-JPL4D-Op
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.userType: Describes whee
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.isCustomMade: Whether the wardrobe item is a Custom Made product (true) or a Ready to Wear product (false).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/1b13f173-a519-455f-b26d-a1685ccda6b5}
 */
export function wardrobeItemClicked(properties: WardrobeItemClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "JhFP9jJk5a4m9Ftp3CMLb", name: "is_custom_made", value: properties.isCustomMade});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertQuantity(properties.quantity));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1b13f173-a519-455f-b26d-a1685ccda6b5", "06349b9a5610eb3b649096dbbbb22fdd98931b2297f45ce5687fb833058250ae", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("wardrobe_item_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1b13f173-a519-455f-b26d-a1685ccda6b5", "wardrobe_item_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'wardrobe_item_clicked': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("wardrobe_item_clicked", eventProperties, "1b13f173-a519-455f-b26d-a1685ccda6b5", "06349b9a5610eb3b649096dbbbb22fdd98931b2297f45ce5687fb833058250ae");
    }
    // destination Segment
    Segment.logEvent("wardrobe_item_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NbaCardViewedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  cardId: string;
  employeeId: string;
  storeId: string;
  locationCode: string;
}
/**
 * nba_card_viewed: Fired when the Next Best Action card is shown on a customer's profile in Customer Hub's in-store view. Use for: the denominator of the NBA feedback response rate, per store and associate. Do not fire when: the NBA trait is empty or the NBA_cards_final flag is off (the card is not rendered).
 * 
 * When to trigger this event:
 * 1. When the Next Best Action card renders on the customer's Overview in Customer Hub's in-store view.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/rZxTlM2otYvyKVekP-DbR/trigger/mx_5YM3MVGP_9ZZshBDVg
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.cardId: Unique ID of the Next Best Action suggestion shown to the style advisor, taken from the NBA Segment trait in the Profile API response. Use for: joining feedback and views back to the generated NBA card (headline, reasons, model version). Example: 'nba_7f3c...'.
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/rZxTlM2otYvyKVekP-DbR}
 */
export function nbaCardViewed(properties: NbaCardViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "3V8G_u4aEZTaB7jnof2UJ", name: "card_id", value: properties.cardId});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "rZxTlM2otYvyKVekP-DbR", "342b51a5b280d0c358c4c51ae16bb0edc6fd899a74e5a8e5e6670728f4abb1c3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("nba_card_viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("rZxTlM2otYvyKVekP-DbR", "nba_card_viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("nba_card_viewed", eventProperties, "rZxTlM2otYvyKVekP-DbR", "342b51a5b280d0c358c4c51ae16bb0edc6fd899a74e5a8e5e6670728f4abb1c3");
    }
    // destination Segment
    Segment.logEvent("nba_card_viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NbaFeedbackSubmittedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  cardId: string;
  employeeId: string;
  storeId: string;
  rating: RatingValueType;
  feedback: string;
  locationCode: string;
}
/**
 * nba_feedback_submitted: Fired once when the style advisor finishes the Next Best Action feedback sheet after tapping thumbs up or thumbs down — on Send feedback, Skip, or closing the sheet. Use for: share of good ratings and qualitative notes to tune the NBA model; response rate together with nba_card_viewed. Do not fire when: the advisor never taps a thumb.
 * 
 * When to trigger this event:
 * 1. When the style advisor taps Send feedback, Skip or the close icon on the NBA feedback sheet opened by thumbs up/down on the Next Best Action card.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/_UHaNkJOxz5M_wphoRCyJ/trigger/NotjE0k4_kabkF2EQeBKY
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.cardId: Unique ID of the Next Best Action suggestion shown to the style advisor, taken from the NBA Segment trait in the Profile API response. Use for: joining feedback and views back to the generated NBA card (headline, reasons, model version). Example: 'nba_7f3c...'.
 * @param properties.employeeId: Employee ID of style advisor in Active Customers List
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.rating: The style advisor's rating of a Next Best Action suggestion: good (thumbs up) or bad (thumbs down). Use for: the share of useful suggestions per card, store and model version.
 * @param properties.feedback: Optional free-text note the style advisor typed in the Next Best Action feedback sheet. Sent as an empty string when they tap Skip or close the sheet without typing. Use for: qualitative review of what made a suggestion useful or wrong, to tune the NBA model. May contain customer details typed by the advisor — review PII/consent handling.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/_UHaNkJOxz5M_wphoRCyJ}
 */
export function nbaFeedbackSubmitted(properties: NbaFeedbackSubmittedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "3V8G_u4aEZTaB7jnof2UJ", name: "card_id", value: properties.cardId});
  eventPropertiesArray.push({id: "Knrwf7RYSa", name: "employee_id", value: properties.employeeId});
  eventPropertiesArray.push({id: "EnoheN1kA", name: "store_id", value: properties.storeId});
  eventPropertiesArray.push({id: "dgKopHqafhYtQjJl3ViLB", name: "rating", value: properties.rating});
  eventPropertiesArray.push({id: "1NKzqn57q6h5IAfU_8Nz0", name: "feedback", value: properties.feedback});
  eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_UHaNkJOxz5M_wphoRCyJ", "4e0f45cdd5e83ff71aaf2f2901f20428acb9662f77cb69f686b64f04ba2c60cb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("nba_feedback_submitted", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_UHaNkJOxz5M_wphoRCyJ", "nba_feedback_submitted", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("nba_feedback_submitted", eventProperties, "_UHaNkJOxz5M_wphoRCyJ", "4e0f45cdd5e83ff71aaf2f2901f20428acb9662f77cb69f686b64f04ba2c60cb");
    }
    // destination Segment
    Segment.logEvent("nba_feedback_submitted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ShowReturnLabelClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  orderId: string;
  userType: UserTypeValueType[];
}
/**
 * show_return_label_clicked: Fired when a customer or style advisor clicks "Show return label" on a Return Registered Active Card in the Customer Hub.
 * Use for: measuring how often the return label is opened from Active Cards, split by user_type.
 * Do not fire when: the return label is opened from the Returns flow or Order details (see returning_item_show_qr_code_clicked).
 * 
 * When to trigger this event:
 * 1. a user clicks "Show return label" on a Return Registered active card
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/YjWS9DZ7otXxgokWsHb0D/trigger/tTBdC7W5_2ixkWeAWmS66
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.orderId: transaction id (native property of ecommerce object within Segment)
 * @param properties.userType: Describes whee
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/YjWS9DZ7otXxgokWsHb0D}
 */
export function showReturnLabelClicked(properties: ShowReturnLabelClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "9aTQ52H3v", name: "order_id", value: properties.orderId});
  eventPropertiesArray.push({id: "WR8LHK70rbl3XW84pUasK", name: "user_type", value: properties.userType});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: "active_card"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "YjWS9DZ7otXxgokWsHb0D", "2adc0e4897aa67ae505ae976fe94ec8b25cc0434877c1665342d04b3df90b3df", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("show_return_label_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("YjWS9DZ7otXxgokWsHb0D", "show_return_label_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("show_return_label_clicked", eventProperties, "YjWS9DZ7otXxgokWsHb0D", "2adc0e4897aa67ae505ae976fe94ec8b25cc0434877c1665342d04b3df90b3df");
    }
    // destination Segment
    Segment.logEvent("show_return_label_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  Tab,
  AddressFields,
  LoggedIn,
  AddressType,
  EventCategory,
  Language,
  PageType,
  UserType,
  Rating,
  Country,
  Currency,
  CardType,
  ApplicationId,
  faqOpen,
  customerInformationEdited,
  customerHubOpened,
  customerSelected,
  returnOrderClicked,
  customerAddressEdited,
  tabClicked,
  returnedToAcl,
  orderClicked,
  communicationPreferencesSaved,
  newArrivalsButtonClicked,
  settingsCustomerInfoClicked,
  settingsAddressBookClicked,
  settingsCommunicationClickled,
  cancellationClicked,
  cancellationApproved,
  cancellationConfirmed,
  trackYourOrderClicked,
  bookPickupAppointmentClicked,
  itemsInCartLoaded,
  wardrobeItemClicked,
  nbaCardViewed,
  nbaFeedbackSubmitted,
  showReturnLabelClicked,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["faqOpen","customerInformationEdited","customerHubOpened","customerSelected","returnOrderClicked","customerAddressEdited","tabClicked","returnedToAcl","orderClicked","communicationPreferencesSaved","newArrivalsButtonClicked","settingsCustomerInfoClicked","settingsAddressBookClicked","settingsCommunicationClickled","cancellationClicked","cancellationApproved","cancellationConfirmed","trackYourOrderClicked","bookPickupAppointmentClicked","itemsInCartLoaded","wardrobeItemClicked","nbaCardViewed","nbaFeedbackSubmitted","showReturnLabelClicked"]
